function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */ import { Popover } from 'antd';
import moment from 'moment';
import { PureComponent } from 'react';
import { queueMacrotask } from 'utils/macrotask';
import { uid } from 'utils/uid';
import { DueDateRangePicker } from './range-picker';
import { DueDateSinglePicker } from './single-picker';
import { DueDatePickerTrigger } from './trigger';
const DATE_FORMAT = 'DD/MM/YYYY';
export const API_DATE_FORMAT = 'YYYY-MM-DD';
/* NOTE:: In the interest of time, copy pasted DueDatePicker component and made some changes to accommodate YYYY-MM-DD.
 * So, CustomDueDatePicker exact replica of DueDatePicker except startDate, dueDate &  onDateChange.
 *  */ export class CustomDueDatePicker extends PureComponent {
    componentDidUpdate({ dueDate: oldDueDate, startDate: oldStartDate }) {
        const { dueDate: newDueDate, startDate: newStartDate } = this.props;
        if (newDueDate !== oldDueDate) {
            this.setDueDate(newDueDate);
        }
        if (newStartDate !== oldStartDate) {
            this.setStartDate(newStartDate);
        }
    }
    setPicker(isRangePicker) {
        this.popoverRefId = isRangePicker ? this.rangePopoverRefId : this.singlePopoverRefId;
        this.setState({
            isRangePicker
        });
    }
    setDueDate(newDueDate) {
        this.setState({
            dueDate: newDueDate ? moment(newDueDate) : null
        });
    }
    setStartDate(newStartDate) {
        this.setState({
            startDate: newStartDate ? moment(newStartDate) : null
        });
    }
    focusInsideFirstInputField() {
        queueMacrotask(()=>{
            const $input = document.querySelector(`#${this.popoverRefId} .ant-picker-input input`);
            if ($input) {
                $input.focus();
            }
        });
    }
    updateDate(values) {
        // rc-picker re-submits on input blur, which can land after the popover closed (a modal took focus) and undo a rejected change.
        if (!this.state.datePickerVisibility) {
            return;
        }
        const [updatedStartDate, updatedDueDate] = values !== null && values !== void 0 ? values : [
            null,
            null
        ];
        this.setState({
            startDate: updatedStartDate,
            dueDate: updatedDueDate
        });
    }
    updateDueDate(date) {
        this.updateDate([
            null,
            date
        ]);
        /* NOTE:: we need to queue the following toggleDatePickerVisibility, as the above updateDate is gonna call setState which is a async. */ queueMacrotask(()=>this.toggleDatePickerVisibility(false));
    }
    updateStartDate(date) {
        this.updateDate([
            date,
            null
        ]);
        queueMacrotask(()=>this.toggleDatePickerVisibility(false));
    }
    clearDates() {
        this.updateDate([
            null,
            null
        ]);
        /* NOTE:: we need to queue the following toggleDatePickerVisibility, as the above updateDate is gonna call setState which is a async. */ queueMacrotask(()=>this.toggleDatePickerVisibility(false));
    }
    modifyPickerType() {
        const { isRangePicker } = this.state;
        this.setPicker(!isRangePicker);
        this.focusInsideFirstInputField();
    }
    pickToday() {
        // do not switch from range picker to single picker if hideModifyPicker is true
        // this will apply in places like timeoff picker where we don't want to allow user to switch from range picker to single picker
        const { hideModifyPicker } = this.props;
        const { useAsStartDatePicker = false } = this.props;
        this.setState({
            isRangePicker: !!hideModifyPicker
        });
        if (useAsStartDatePicker) {
            return this.updateStartDate(moment().startOf('day'));
        }
        return this.updateDueDate(moment().startOf('day'));
    }
    pickTomorrow() {
        // do not switch from range picker to single picker if hideModifyPicker is true
        // this will apply in places like timeoff picker where we don't want to allow user to switch from range picker to single picker
        const { hideModifyPicker } = this.props;
        const { useAsStartDatePicker = false } = this.props;
        this.setState({
            isRangePicker: !!hideModifyPicker
        });
        if (useAsStartDatePicker) {
            return this.updateStartDate(moment().clone().add(1, 'day').startOf('day'));
        }
        return this.updateDueDate(moment().clone().add(1, 'day').startOf('day'));
    }
    toggleDatePickerVisibility(visibility) {
        const { props: { onDateChange }, state } = this;
        // call onDateChange when the popover closes.
        if (!visibility && onDateChange) {
            var _ref, _ref1;
            var _state_startDate, _state_dueDate;
            const accepted = onDateChange([
                (_ref = (_state_startDate = state.startDate) === null || _state_startDate === void 0 ? void 0 : _state_startDate.format(API_DATE_FORMAT)) !== null && _ref !== void 0 ? _ref : null,
                (_ref1 = (_state_dueDate = state.dueDate) === null || _state_dueDate === void 0 ? void 0 : _state_dueDate.format(API_DATE_FORMAT)) !== null && _ref1 !== void 0 ? _ref1 : null
            ]);
            if (accepted === false) {
                this.setStartDate(this.props.startDate);
                this.setDueDate(this.props.dueDate);
            }
        }
        this.setState({
            datePickerVisibility: visibility
        });
    }
    showDatePicker() {
        this.toggleDatePickerVisibility(true);
        this.focusInsideFirstInputField();
    }
    closeDatePicker() {
        this.toggleDatePickerVisibility(false);
    }
    popupContainer() {
        return document.getElementById(this.popoverRefId);
    }
    render() {
        const { datePickerVisibility, isRangePicker, startDate, dueDate } = this.state;
        const { canChooseStartDate = true, useAsStartDatePicker = false, hideFooter, isTodayDisabled: isTodayDisabledProp, isTomorrowDisabled: isTomorrowDisabledProp, footerText, endDateText, endDateTextRange, disallowSingleDate, hideModifyPicker, hideClearDate, className, renderTrigger, block, disabled, id, placeholder, overlayClassName, size = 'middle', disabledDate, picker, hideTrigger, dateRenderer, hideIcon = false, handleOnFocus, placement, panelRender } = this.props;
        const { clearDates, pickToday, pickTomorrow, modifyPickerType, showDatePicker, toggleDatePickerVisibility, updateDate, updateStartDate, updateDueDate, popupContainer, closeDatePicker } = this;
        const hasValue = !!(startDate || dueDate);
        const dateValue = useAsStartDatePicker ? startDate : dueDate;
        const updateDates = useAsStartDatePicker ? updateStartDate : updateDueDate;
        // Calculate if today/tomorrow are disabled if not explicitly provided
        const today = moment().startOf('day');
        const tomorrow = moment().add(1, 'day').startOf('day');
        const isTodayDisabled = isTodayDisabledProp !== null && isTodayDisabledProp !== void 0 ? isTodayDisabledProp : disabledDate ? disabledDate(today) : false;
        const isTomorrowDisabled = isTomorrowDisabledProp !== null && isTomorrowDisabledProp !== void 0 ? isTomorrowDisabledProp : disabledDate ? disabledDate(tomorrow) : false;
        const displayTrigger = ()=>{
            if (hideTrigger) {
                return null;
            }
            if (renderTrigger) {
                return renderTrigger(showDatePicker);
            }
            return /*#__PURE__*/ _jsx(DueDatePickerTrigger, {
                className: className,
                block: block,
                disabled: disabled,
                hasValue: hasValue,
                id: id,
                placeholder: placeholder,
                size: size,
                startDate: startDate,
                dueDate: dueDate,
                onClick: ()=>{
                    showDatePicker();
                },
                hideIcon: hideIcon
            });
        };
        return /*#__PURE__*/ _jsx(Popover, {
            id: this.popoverRefId,
            content: isRangePicker ? /*#__PURE__*/ _jsx(DueDateRangePicker, {
                disallowSingleDate: disallowSingleDate,
                hideModifyPicker: hideModifyPicker,
                hideClearDate: hideClearDate,
                canChooseStartDate: canChooseStartDate,
                getPopupContainer: popupContainer,
                format: DATE_FORMAT,
                value: [
                    startDate,
                    dueDate
                ],
                updateDateRange: updateDate,
                clearDates: clearDates,
                pickToday: pickToday,
                hideFooter: hideFooter,
                endDateTextRange: endDateTextRange,
                footerText: footerText,
                pickTomorrow: pickTomorrow,
                modifyPickerType: modifyPickerType,
                onDone: closeDatePicker,
                onFocus: handleOnFocus,
                disabledDate: (curr)=>{
                    var _ref;
                    return (_ref = disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(curr, startDate, dueDate)) !== null && _ref !== void 0 ? _ref : false;
                },
                dateRenderer: dateRenderer,
                isTodayDisabled: isTodayDisabled,
                isTomorrowDisabled: isTomorrowDisabled,
                panelRender: panelRender !== null && panelRender !== void 0 ? panelRender : undefined
            }) : /*#__PURE__*/ _jsx(DueDateSinglePicker, {
                endDateText: endDateText,
                footerText: footerText,
                canChooseStartDate: canChooseStartDate,
                useAsStartDatePicker: useAsStartDatePicker,
                hideClearDate: hideClearDate,
                getPopupContainer: popupContainer,
                value: dateValue,
                format: DATE_FORMAT,
                updateDates: updateDates,
                clearDates: clearDates,
                pickToday: pickToday,
                hideFooter: hideFooter,
                pickTomorrow: pickTomorrow,
                modifyPickerType: modifyPickerType,
                onDone: closeDatePicker,
                disabledDate: disabledDate,
                dateRenderer: dateRenderer,
                picker: picker,
                isTodayDisabled: isTodayDisabled,
                isTomorrowDisabled: isTomorrowDisabled
            }),
            placement: placement !== null && placement !== void 0 ? placement : 'bottomLeft',
            trigger: "click",
            open: datePickerVisibility,
            onOpenChange: toggleDatePickerVisibility,
            overlayClassName: `due__date__picker ${overlayClassName || ''}`,
            destroyTooltipOnHide: true,
            children: displayTrigger()
        });
    }
    constructor(props){
        super(props), _define_property(this, "singlePopoverRefId", void 0), _define_property(this, "rangePopoverRefId", void 0), _define_property(this, "popoverRefId", '');
        this.rangePopoverRefId = uid('due-date-picker-range');
        this.singlePopoverRefId = uid('due-date-picker-single');
        const { startDate, dueDate, initialVisibile, isRangePicker: isRangePickerProps } = props;
        const isRangePicker = isRangePickerProps || !!startDate;
        this.state = {
            datePickerVisibility: !!initialVisibile,
            startDate: startDate ? moment(startDate) : null,
            dueDate: dueDate ? moment(dueDate) : null,
            isRangePicker
        };
        this.updateDate = this.updateDate.bind(this);
        this.updateStartDate = this.updateStartDate.bind(this);
        this.updateDueDate = this.updateDueDate.bind(this);
        this.clearDates = this.clearDates.bind(this);
        this.modifyPickerType = this.modifyPickerType.bind(this);
        this.pickToday = this.pickToday.bind(this);
        this.pickTomorrow = this.pickTomorrow.bind(this);
        this.toggleDatePickerVisibility = this.toggleDatePickerVisibility.bind(this);
        this.showDatePicker = this.showDatePicker.bind(this);
        this.closeDatePicker = this.closeDatePicker.bind(this);
        this.popupContainer = this.popupContainer.bind(this);
        this.focusInsideFirstInputField = this.focusInsideFirstInputField.bind(this);
        this.setPicker = this.setPicker.bind(this);
        this.setDueDate = this.setDueDate.bind(this);
        this.setStartDate = this.setStartDate.bind(this);
        this.setPicker(isRangePicker);
    }
}
